var _path, _path2, _path3, _path4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYtdincome(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1217_65976)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9312 19.8262L11.2822 16.1789",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8435 21.2126L10.1946 17.5653",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6654 21.7434L9.10693 18.9516",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1217_65976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1217_65976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3458 19.2649C17.3919 18.959 17.2733 18.6394 17.0194 18.44C17.0193 18.4398 17.0191 18.4397 17.019 18.4396C13.5967 15.7547 12.5186 14.9167 12.1765 14.6381C11.8903 14.3719 11.497 14.2541 11.1112 14.3167C10.8067 14.3663 10.5036 14.4231 10.2132 14.4842C9.79073 14.573 9.35128 14.3501 9.20137 13.9415C9.04092 13.5041 9.25664 13.013 9.69501 12.8398L12.0126 11.9242L11.3692 11.67C10.6784 11.397 9.94476 11.2505 9.20221 11.2364C8.28337 11.219 6.9097 11.0522 5.95804 10.3057L4.30157 9.00612C4.09007 8.84014 3.78431 8.876 3.61692 9.08633L0.458011 13.055C0.288932 13.2674 0.325214 13.5769 0.538823 13.7445L2.74692 15.4768C3.57543 16.1269 4.33593 16.8579 5.03376 17.6466C5.71785 18.4198 6.47404 19.1259 7.28629 19.7631L11.5611 23.1169C11.937 23.4118 12.4864 23.3706 12.7945 23.0054C13.1179 22.6221 13.0567 22.0504 12.6653 21.7435L13.7392 22.5859C14.115 22.8808 14.6645 22.8396 14.9726 22.4745C15.2961 22.0911 15.2348 21.5195 14.8435 21.2125L15.9238 22.06C16.315 22.3669 16.8848 22.2903 17.1802 21.885C17.4616 21.4988 17.3707 20.9554 16.9949 20.6605L15.9312 19.826C16.462 20.2424 17.2454 19.9306 17.3458 19.2649Z",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3072 4.66528C10.9487 4.45261 10.7109 4.07972 10.7109 3.65527C10.7109 2.99395 11.288 2.4578 11.9999 2.4578C12.7117 2.4578 13.2888 2.99395 13.2888 3.65527",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.06159V4.46094",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.80799C12.7118 8.80799 13.2888 9.3441 13.2888 10.0054C13.2888 10.6668 12.7118 11.2029 11.9999 11.2029C11.288 11.2029 10.7109 10.6668 10.7109 10.0054",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.80811C11.288 8.80811 10.7109 8.272 10.7109 7.61068C10.7109 6.94932 11.288 6.41321 11.9999 6.41321C12.7118 6.41321 13.2888 6.94932 13.2888 7.61068",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.01668V11.5991",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20221 11.2363C9.94476 11.2504 10.6784 11.397 11.3692 11.6699L12.0126 11.9241L12.6561 11.6699C13.3468 11.397 14.0805 11.2504 14.8231 11.2363C15.0022 11.2329 15.1986 11.2237 15.4058 11.2058C15.884 10.5278 16.1651 9.7007 16.1651 8.80796C16.1651 6.50767 14.3003 4.64293 12 4.64293C9.6997 4.64293 7.83496 6.50767 7.83496 8.80796C7.83496 9.69967 8.11532 10.5258 8.59251 11.2034C8.80954 11.2229 9.01537 11.2328 9.20221 11.2363Z",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.765 16.8236C20.2425 16.3455 20.7462 15.8943 21.2783 15.4768L23.4612 13.7643C23.6746 13.5968 23.711 13.2876 23.5423 13.0751L20.3878 9.103C20.2206 8.8923 19.9145 8.8563 19.7028 9.02238L18.0671 10.3056C17.1156 11.0522 15.7419 11.2189 14.8231 11.2364C14.0805 11.2504 13.3468 11.397 12.656 11.6699L12.0126 11.9241L9.69502 12.8398C9.25665 13.013 9.04088 13.504 9.20138 13.9414C9.35129 14.35 9.7907 14.5729 10.2132 14.4841C10.5036 14.4231 10.8068 14.3662 11.1112 14.3167C11.497 14.254 11.8903 14.3718 12.1764 14.6381C12.5185 14.9167 13.5967 15.7546 17.019 18.4396C17.2777 18.6426 17.3915 18.9613 17.3458 19.2649C17.7984 18.8763 18.2308 18.4645 18.6401 18.0305",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9856 3.64053C15.4665 1.93151 13.8786 0.687634 12 0.687634C9.69969 0.687634 7.83496 2.55242 7.83496 4.85271C7.83496 5.56845 8.01557 6.24199 8.33357 6.83032C9.03763 5.52776 10.4154 4.64285 12 4.64285C13.5846 4.64285 14.9624 5.52776 15.6664 6.83032C15.9202 6.36092 16.0861 5.83718 16.1429 5.28115",
    stroke: "white",
    strokeWidth: 0.878906,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1217_65976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtdincome);
export default __webpack_public_path__ + "static/media/ytdincome.60aca99bcedec227fcfbb2438f874ba8.svg";
export { ForwardRef as ReactComponent };